/**
 * This function was adapted from the one in the ReadMe of https://github.com/DominicTobias/react-image-crop
 * @param {File} imageSrc - Image File url
 * @param {Object} pixelCrop - pixelCrop Object provided by react-easy-crop
 * @param {number} rotation - optional rotation parameter
 */

const createImage = async (url: any) =>
  await new Promise((resolve, reject) => {
    const image = new Image();
    image.addEventListener('load', () => resolve(image));
    image.addEventListener('error', (error) => reject(error));
    image.setAttribute('crossOrigin', 'anonymous'); // needed to avoid cross-origin issues on CodeSandbox
    image.src = url;
  });

function getRadianAngle(degreeValue: any) {
  return (degreeValue * Math.PI) / 180;
}

export default async function getCroppedImg(
  imageSrc: any,
  pixelCrop: any,
  rotation = 0
) {
  const image: any = await createImage(imageSrc);
  image.crossOrigin = 'anonymous';
  const canvas = document.createElement('canvas');
  const ctx: any = canvas.getContext('2d');

  const maxSize = Math.max(image.width, image.height);
  const safeArea = maxSize * Math.sqrt(2);

  // set each dimensions to double largest dimension to allow for a safe area for the
  // image to rotate in without being clipped by canvas context
  canvas.width = safeArea;
  canvas.height = safeArea;

  // translate canvas context to a central location on image to allow rotating around the center.

  var sourceX = pixelCrop?.x;
  var sourceY = pixelCrop?.y;
  var sourceWidth = image.width - sourceX; // you're in the bounds
  var sourceHeight = image.height;

  // draw rotated image and store data.
  try {
    ctx.drawImage(
      image,

      safeArea / 2 - image.width * 0.5, //noi dat anh len canvas -> bat buoc
      safeArea / 2 - image.height * 0.5 //noi dat anh len canvas -> bat buoc
    );
  } catch (err) {
    console.log('error: DRAW IMAGE FAILED');
  }

  const data = await ctx.getImageData(5, 5, safeArea, safeArea);
  console.log('data image: ');
  console.log(data);
  let found1 = 'Left canvas does have transparency';
  for (let i = 0; i < data.data.length; i += 4) {
    if (data.data[i + 3] > 0) {
      found1 = 'Left canvas does not have transparency';

      break;
    }
  }

  if (found1 === 'Left canvas does have transparency') return false;

  console.log(found1);

  // set canvas width to final desired crop size - this will clear existing context
  canvas.width = (pixelCrop?.width && pixelCrop.width) || image.width;
  canvas.height = (pixelCrop?.height && pixelCrop.height) || image.height;

  // paste generated rotate image with correct offsets for x,y crop values.
  ctx.putImageData(
    data,
    0 - safeArea / 2 + image.width * 0.5 - ((pixelCrop?.x && pixelCrop.x) || 0),
    0 - safeArea / 2 + image.height * 0.5 - ((pixelCrop?.y && pixelCrop.y) || 0)
  );

  // As Base64 string
  // return canvas.toDataURL("image/jpeg");

  return canvas;
}

export const generateDownload = async (imageSrc: any, crop: any) => {
  if (!crop || !imageSrc) {
    return;
  }
  console.log('here');
  const canvas = (await getCroppedImg(imageSrc, crop)) as any;
  console.log(canvas);

  canvas.toBlob(
    (blob: any) => {
      if (blob !== null && blob !== false) {
        const previewUrl = window.URL.createObjectURL(blob);

        const anchor = document.createElement('a');
        anchor.download = 'image.jpeg';
        anchor.href = URL.createObjectURL(blob);
        anchor.click();

        window.URL.revokeObjectURL(previewUrl);
      }
    },
    'image/jpeg',
    0.66
  );
};

export const dataURLtoFile = (dataurl: string, filename: string) => {
  var arr: Array<any> = dataurl.split(','),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n);

  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }

  return new File([u8arr], filename, { type: mime });
};
